import React, { useState } from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Button from "../../../../shared/components/atoms/button/button"
import decorationMobile from "../../../../assets/images/muestreo/decoration-mobile.svg"

const StepThree = props => {
  let {
    details,
    params,
    randomKey,
    handleSubmit,
    randomNum,
    randomQuestion,
    answer,
    setAnswer,
    setCount,
    count,
    hasError,
    servOk,
    servMessage,
    ACTIVITY_ID_MUESTREO,
  } = props

  return (
    <div className="container">
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-left rounded-top-left-no-mov hidden-mov-large background-color-primary" />
      ) : null}
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-top-mov background-color-primary" />
      ) : null}
      <div
        className={
          "details rounded-top-no-mov activity-modal-style " +
          (["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO)
            ? "muestra-gratis-antibacterial container-step-background"
            : "muestreo-normal")
        }
      >
        <div
          className={
            "details-step-four " +
            (ACTIVITY_ID_MUESTREO == "48"
              ? "muestreo-special-container"
              : ACTIVITY_ID_MUESTREO == "91" || ACTIVITY_ID_MUESTREO == "92"
                ? "muestreo-special-100"
                : "muestreo-normal-container")
          }
        >
          <div className="description">
            {(details = []) &&
              documentToReactComponents(
                params.contenidoActividadMuestreo.json,
                {
                  renderNode: {
                    [BLOCKS.HEADING_1]: (node, children) => {
                      details.push(
                        <h1
                          key={randomKey}
                          className={
                            "text-color-secondary " +
                            (ACTIVITY_ID_MUESTREO == "48"
                              ? "muestreo-special"
                              : "muestreo-normal")
                          }
                        >
                          {children}
                        </h1>,
                      )
                    },
                    [BLOCKS.PARAGRAPH]: (node, children) => {
                      details.push(
                        <p
                          key={randomKey}
                          className={
                            (["141", "143", "192", "194"].includes(ACTIVITY_ID_MUESTREO) ? "text-color-primary " : "text-color-tertiary ") +
                            (ACTIVITY_ID_MUESTREO == "48"
                              ? "muestreo-special"
                              : "muestreo-normal")
                          }
                        >
                          {children}
                        </p>,
                      )
                    },
                    [BLOCKS.EMBEDDED_ASSET]: node => (
                      <img
                        key={randomKey}
                        className="image-step-two hidden-mov-large"
                        src={
                          node.data.target.fields.file[process.env.LOCALE].url
                        }
                      />
                    ),
                  },
                },
              )}
            <div className="text text-color-primary">{details}</div>
          </div>
          <form id="roulette" onSubmit={handleSubmit}>
            <div
              className={`${
                // !["48", "91", "92", "137", "138", "141"].includes(ACTIVITY_ID_MUESTREO)
                !["48", "91", "92", "137", "138", "141", "143", "192", "194"].includes(ACTIVITY_ID_MUESTREO)
                  ? `background-color-question`
                  : ACTIVITY_ID_MUESTREO == "91" || ACTIVITY_ID_MUESTREO == "92"
                    ? `background-color-question`
                    : `background-color-question`
                } paragraph-step-three`}
            >
              {randomQuestion && (
                <div className="question">
                  {/* {randomQuestion.image &&
                  ACTIVITY_ID_MUESTREO != "91" &&
                  ACTIVITY_ID_MUESTREO != "92" ? (
                    <img src={randomQuestion.image} />
                  ) : null} */}
                  <h2 className={`text-color-question`}>
                    Tu pregunta es:
                  </h2>
                  <p className={`text-color-question`}>
                    {randomQuestion.question}
                  </p>
                </div>
              )}
              <div className="user-input">
                <textarea
                  required
                  className={`textarea`}
                  placeholder="Escribe tu respuesta"
                  value={answer}
                  onChange={e => {
                    e.persist()
                    setAnswer(e.target.value)
                    setCount(e.target.value.length)
                  }}
                  maxLength={400}
                ></textarea>
                <span className="textarea__count">{count} / 400</span>
              </div>
            </div>
            {hasError && (
              <span className={`serv-message${servOk ? "" : "-error"}`}>
                Escribe tu respuesta
              </span>
            )}
            {servMessage && (
              <span
                className={`serv-message${servOk ? "" : "-error"} ${ACTIVITY_ID_MUESTREO != "91" &&
                    ACTIVITY_ID_MUESTREO != "92" &&
                    ACTIVITY_ID_MUESTREO != "141" &&
                    ACTIVITY_ID_MUESTREO != "192" &&
                    ACTIVITY_ID_MUESTREO != "194" &&
                    ACTIVITY_ID_MUESTREO != "143"
                    ? "activity-antibacterial"
                    : ""
                  }`}
              >
                {servMessage}
              </span>
            )}
            <Button
              form="roulette"
              type="submit"
              className={`button ${(["141", "143"].includes(ACTIVITY_ID_MUESTREO)) ? "background-color-quaternary " : "background-color-primary-button"}`}
              title="Enviar respuesta"
            />
          </form>
        </div>
      </div>
      {!["48", "91", "92", "137", "138"].includes(ACTIVITY_ID_MUESTREO) ? (
        <div className="decoration-right rounded-top-right-no-mov hidden-mov-large background-color-primary" />
      ) : null}
    </div>
  )
}

export default StepThree
